module.exports = __webpack_public_path__ + "media/images/autopilot/setup_step_3-cebb15103928d5ab17d2787ce111e0a7.svg";